<div class="thumbnail-container">
  <div
    [ngStyle]="{ 'background-image': 'url(' + defaultImageSource + ')' }"
    class="thumbnail"></div>
  <div
    (click)="triggerClick()"
    class="overlay"
    [ngClass]="{ active: thumbnailSource.length === 0 || uploadInProgress }">
    <p *ngIf="!uploadInProgress">
      <span class="fa fa-upload"></span>
      &nbsp;Select Picture
    </p>
    <p *ngIf="uploadInProgress">Uploading ...</p>
    <input
      type="file"
      #image
      name="image"
      (change)="handleFileInput($any($event.target).files)"
      accept="'image/*'"
      hidden />
  </div>
</div>
